import { observable } from 'mobx';
import { persist } from 'mobx-persist';

import { RootStore } from './rootStore';

import { AvailableLanguages } from '../i18n';

class SettingStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @persist @observable language: AvailableLanguages = 'jp';
}

export default SettingStore;
